import { Clickable } from '@carvana/merch-components';
import { useContext } from 'react';
import menuOptions, { MenuOptionLabel } from '~/constants/srp/MenuOption';
import ModalContext from '~/context/srp/ModalContext';
import SearchContext from '~/context/srp/SearchContext';

export default function MenuOptions() {
  const { setFilterModalOpen } = useContext(ModalContext);
  const { setExpandOnOpen } = useContext(SearchContext);

  const handleClick = (option: MenuOptionLabel) => {
    setExpandOnOpen(option);
    setFilterModalOpen(true);
  };

  return (
    <div className="block border-0 border-b border-solid border-grey-2 px-16 pb-16 m:hidden">
      <div className="flex items-center gap-8">
        {menuOptions.map(({ key, label }) => (
          <Clickable
            data-analytics-id="Filter Menu"
            data-analytics-attributes={JSON.stringify({
              item: 'shortcut button',
              label
            })}
            data-qa={`menu-option-${key}`}
            className="rounded-[20px] border border-solid border-grey-2 px-12 py-8 text-blue-6 tl-body-xs min-[387px]:tl-body-s" // below device width 387px the text stacks added custom breakpoint to change text size to fit in one line
            onClick={() => handleClick(label)}
            key={key}
          >
            {label}
          </Clickable>
        ))}
      </div>
    </div>
  );
}
